import { render, staticRenderFns } from "./FlatsInformation.vue?vue&type=template&id=8570ed7e&scoped=true&"
import script from "./FlatsInformation.vue?vue&type=script&lang=ts&"
export * from "./FlatsInformation.vue?vue&type=script&lang=ts&"
import style0 from "./FlatsInformation.vue?vue&type=style&index=0&id=8570ed7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8570ed7e",
  null
  
)

export default component.exports